import ActionType from "./action-type"


const storeSideBarMenuItem = (data) => ({
    type: ActionType.sideBarMenuItems,
    data: data
})


const storeProfileData = (data) => ({
    type: ActionType.profileData,
    data: data
})

const storeToastStatus = (data) => ({
    type: ActionType.isToastOpen,
    open: data
})

const accountBalance = (data) => ({
    type: ActionType.accountBalance,
    data: data
})

const dynamicMenus = (data) => ({
    type: ActionType.dynamicMenu,
    data: data
})

const logout = () => ({
    type: ActionType.logout,
})






export default {
    storeSideBarMenuItem,
    storeProfileData,
    storeToastStatus,
    accountBalance,
    dynamicMenus,
    logout
}